module.exports = __webpack_public_path__ + "img/nothing.6ae89501.png";